import React, { useEffect, useState } from 'react';
import { Button, TextField, Box, MenuItem } from '@mui/material';
import SysfarLogo from '../../../assets/img/sysfar-logo.png';
import httpClient from '../../../assets/api/http-client';
import styles from './ChatLogin.module.css';

const ChatLogin = ({ handleLogin, ...props }) => {
  const [user, setUser] = useState('');
  const [code, setCode] = useState('');
  const [nameError, setNameError] = useState(false);
  const [codeError, setCodeError] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [serviceGroupId, setServiceGroupId] = useState('');
  const [deptError, setDeptError] = useState('');
  let isValid = true;

  // Departamentos habilitados a aparecer no dropdown do cliente.
  useEffect(() => {
    httpClient.get('/groups/client-list')
      .then((res) => setDepartments(Array.isArray(res.data) ? res.data : []))
      .catch(() => setDepartments([]));
  }, []);

  const validate = () => {

    if (!user.trim()) {
      setNameError('Campo obrigatório');
      isValid = false;
    } else {
      setNameError('');
    }

    if (!code.trim()) {
      setCodeError('Campo obrigatório');
      isValid = false;
    } else if (!props.codeError) { // Limpa o erro se não houver erro via props
      setCodeError('');
      props.codeErrorCallback('')
    }

    // Departamento só é obrigatório quando há opções configuradas.
    if (departments.length > 0 && !serviceGroupId) {
      setDeptError('Selecione um departamento');
      isValid = false;
    } else {
      setDeptError('');
    }

    return isValid;
  };

  const initiateLogin = () => {
    if (validate()) {
      handleLogin(user, code, serviceGroupId || undefined);
      props.codeErrorCallback('')
      setCodeError('');
      localStorage.setItem('welcomeMessageSent', false);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    initiateLogin();
  }

  useEffect(() => {
    if (props.codeError) {
      setCodeError(props.codeError);
      isValid = false;
    }

    if (props.nameError) {
      setNameError(props.nameError);
      isValid = false;
    }
  }, [props.codeError, props.nameError]);

  const fieldSx = {
    '& .MuiInputLabel-root': { color: 'var(--text-muted)', fontSize: '0.9375rem' },
    '& .MuiInputLabel-root.Mui-focused': { color: 'var(--accent)' },
    '& .MuiInput-underline:before': { borderColor: 'var(--border)' },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderColor: 'var(--border-strong)' },
    '& .MuiInput-underline:after': { borderColor: 'var(--accent)' },
    '& .MuiInputBase-input': { color: 'var(--text-primary)', fontSize: '0.9375rem' },
  };

  return (
    <Box className={styles.login}>
      <Box className={styles.loginCard}>
        <Box className={styles.loginImg}>
          <img src={SysfarLogo} alt="Sysfar" />
          <p className={styles.loginSubtitle}>Para continuar, identifique-se com seu nome e registro.</p>
        </Box>
        <Box className={styles.loginInputs}>
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            <TextField variant='standard' label='Nome' required
              onChange={({ target }) => setUser(target.value)}
              error={!!nameError}
              helperText={nameError}
              sx={fieldSx}
            />
            <TextField variant='standard' label='Registro' required
              onChange={({ target }) => setCode(target.value)}
              error={!!codeError}
              helperText={codeError}
              type='number'
              sx={{ ...fieldSx, mt: 1.5 }}
            />
            {departments.length > 0 && (
              <TextField variant='standard' select label='Departamento' required
                value={serviceGroupId}
                onChange={({ target }) => setServiceGroupId(target.value)}
                error={!!deptError}
                helperText={deptError}
                sx={{ ...fieldSx, mt: 1.5 }}
              >
                {departments.map((d) => (
                  <MenuItem key={d.id} value={d.id}>{d.name}</MenuItem>
                ))}
              </TextField>
            )}
            <Box sx={{ marginTop: '1.5rem' }}>
              <Button
                fullWidth
                sx={{
                  backgroundColor: 'var(--accent)',
                  color: '#fafaf9',
                  textTransform: 'none',
                  fontWeight: 600,
                  borderRadius: '9999px',
                  py: 1.1,
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: 'var(--accent-hover)',
                    boxShadow: 'none',
                  },
                }}
                onClick={handleSubmit}
                type="submit"
                variant='contained'
              >
                Iniciar atendimento
              </Button>
            </Box>
          </form>
        </Box>
      </Box>
    </Box>
  );
};

export default ChatLogin;
